module.exports = __webpack_public_path__ + "static/media/img-home3.68d75ed9.jpg";